<ng-container *ngIf="parent?.active">
    <ng-container *ngIf="!parent.loading && !parent.showTables && parent.hasData && parent.showWarnings">
        <div class="requestView errorMessages">
            <span class="spacer"></span>
            <img
                src="assets/request-analytics.svg"
                class="requestIcon"
                alt="Request analytics icon"
            />
            <h5>Unable to retrieve analytics</h5>
            <ul *ngIf="parent.integrationJsonMessage">
                <li *ngFor="let message of parent.integrationJsonMessage">
                {{ message }}
                </li>
            </ul>
            <ul *ngIf="parent.integrationJsonValidationMessages">
                <li *ngFor="let message of parent.integrationJsonValidationMessages">
                {{ message }}
                </li>
            </ul>
            <span class="spacer"></span>
        </div>
    </ng-container>

    <ng-container *ngIf="!parent.loading && !parent.showTables && !parent.hasData && !parent.showWarnings">
        <div class="requestView">
            <span class="spacer"></span>
            <img
                src="assets/request-analytics.svg"
                class="requestIcon"
                alt="Request analytics icon"
            />
            <ng-container *ngIf="'REQUEST_REFRESH_PRODUCT_ANALYTICS' | notRestricted; else noPermissionAndNotExecuted">
                <ng-container [ngSwitch]="parent.analyticsManuallyRequested">
                    <button *ngSwitchCase="false"
                        class="btn btn-primary requestButton"
                        (click)="parent.requestAnalyticsTriggerModal()"
                        [disabled]="parent.disableRequestButton">
                        Request Analytics
                    </button>
                    <ng-container *ngSwitchCase="true" [ngSwitch]="parent.fourHundred">
                        <ng-container *ngSwitchCase="true">
                            <h5>No Data Available</h5>
                            <p>Information missing, unable to retrieve data.</p>
                        </ng-container>
                        <ng-container *ngSwitchCase="false">
                            <h5>Request submitted</h5>
                            <p>Results pending...</p>
                            <button
                                class="btn btn-outline-primary refreshButton"
                                (click)="parent.fetchAnalytics()">
                            Refresh
                            </button>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #noPermissionAndNotExecuted>
                <h5>Analytics not executed for this Product.</h5>
                <p>Please contact the Product Governance team to request Analytics execution.</p>
            </ng-template>
            <span class="spacer"></span>
        </div>
    </ng-container>
</ng-container>